import { render, staticRenderFns } from "./AccountsType.vue?vue&type=template&id=41f53c3a&scoped=true"
import script from "./AccountsType.vue?vue&type=script&lang=js"
export * from "./AccountsType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f53c3a",
  null
  
)

export default component.exports